var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BindingEngine } from 'aurelia-binding';
import { autoinject } from 'aurelia-dependency-injection';
import { RegexValidation } from "./base-validations/regex-validation";
import { CompareValidation } from "./base-validations/compare-validation";
import { DateValidation } from "./base-validations/date-validation";
import { ValidationTypeEnum, ValidationActivation } from "./validations.models";
import { CustomValidationRenderer } from "./custom-validation-renderer";
import { validateTrigger, ValidationController, ValidationRules } from "aurelia-validation";
var EntityValidationsService = /** @class */ (function () {
    function EntityValidationsService(validationController, bindingEngine) {
        this.validationController = validationController;
        this.bindingEngine = bindingEngine;
        this.dateValidator = new DateValidation();
        this.compareValidator = new CompareValidation();
        this.regexValidation = new RegexValidation();
        this.customRenderer = new CustomValidationRenderer();
        this.validationController.addRenderer(new CustomValidationRenderer());
        this.validationController.validateTrigger = validateTrigger.manual;
    }
    EntityValidationsService.prototype.changeValidationRenderer = function (validationRenderer) {
        this.validationController.removeRenderer(this.customRenderer);
        this.validationController.removeRenderer(validationRenderer);
        this.validationController.addRenderer(validationRenderer);
    };
    EntityValidationsService.prototype.getValidator = function (entity, rulesHolder) {
        var subscriptions = [];
        this.injectValidationRulesInEntity(rulesHolder, entity, subscriptions);
        var validator = new ClientSideValidator(this.validationController, subscriptions);
        return validator;
    };
    EntityValidationsService.prototype.getValidatorForArray = function (arrayOfEntities, rulesHolder) {
        var _this = this;
        var subscriptions = [];
        arrayOfEntities.forEach(function (x) {
            _this.injectValidationRulesInEntity(rulesHolder, x, subscriptions);
        });
        var validator = new ClientSideValidator(this.validationController, subscriptions);
        return validator;
    };
    EntityValidationsService.prototype.validateEntity = function () {
        return this.validationController.validate();
    };
    EntityValidationsService.prototype.evaluateActivation = function (obj, rulesHolder) {
        switch (rulesHolder.activation) {
            case ValidationActivation.Always: {
                return true;
            }
            case ValidationActivation.OnlyWhenAllFieldFilled: {
                return !rulesHolder.rules.some(function (x) { return !obj[x.property]; });
            }
            case ValidationActivation.OnlyWhenAnyFieldFilled: {
                return rulesHolder.rules.some(function (x) { return obj[x.property]; }) || obj.id > 0;
            }
        }
    };
    EntityValidationsService.prototype.injectValidationRulesInEntity = function (rulesHolder, item, subscriptions) {
        var _this = this;
        if (rulesHolder === null || rulesHolder === undefined) {
            return null;
        }
        ;
        var ruleValidation;
        var _loop_1 = function (i) {
            var rule = rulesHolder.rules[i];
            if (Object.keys(rule).length === 0 && rule.constructor === Object) {
                return "continue";
            }
            var path = rule.property;
            ruleValidation = ruleValidation === undefined ? ValidationRules.ensure(path) : ruleValidation.ensure(path);
            var parameters = rule.parameters ? JSON.parse(rule.parameters) : {};
            switch (rule.validationType) {
                case ValidationTypeEnum.Required:
                    {
                        ruleValidation = ruleValidation.required().when(function (x) { return _this.evaluateActivation(x, rulesHolder); });
                    }
                    break;
                case ValidationTypeEnum.Range:
                    ruleValidation = ruleValidation
                        .satisfies(function (x) { return x === null || Number(x) >= Number(parameters.Minimum ? parameters.Minimum : parameters.minimum)
                        && Number(x) <= Number(parameters.Maximum ? parameters.Maximum : parameters.maximum); })
                        .when(function (x) { return _this.evaluateActivation(x, rulesHolder); })
                        .withMessage(rule.errorMessage);
                    break;
                case ValidationTypeEnum.MaxLenght:
                    ruleValidation = ruleValidation
                        .satisfies(function (x) {
                        var response = x === null || Number(x.toString().length) <= Number(parameters.Length);
                        return response;
                    })
                        .when(function (x) { return _this.evaluateActivation(x, rulesHolder); })
                        .withMessage(rule.errorMessage);
                    break;
                case ValidationTypeEnum.MinLenght:
                    ruleValidation = ruleValidation
                        .satisfies(function (x) {
                        var response = x === null || Number(x.toString().length) >= Number(parameters.Length);
                        return response;
                    })
                        .when(function (x) { return _this.evaluateActivation(x, rulesHolder); })
                        .withMessage(rule.errorMessage);
                    break;
                case ValidationTypeEnum.RegularExpression:
                    {
                        var regex_1 = new RegExp(parameters.Pattern);
                        ruleValidation = ruleValidation
                            .satisfies(function (x) { return x === null || x === undefined || x === "" || _this.regexValidation.validate(regex_1, x.toString()); })
                            .when(function (x) { return _this.evaluateActivation(x, rulesHolder); })
                            .withMessage(rule.errorMessage);
                    }
                    break;
                case ValidationTypeEnum.Email:
                    {
                        ruleValidation = ruleValidation
                            .satisfies(function (x) { return x === null || x === undefined || x === "" || _this.regexValidation.validate(/^([\w!.%+\-])+@([\w\-])+(?:\.[\w\-]+)+$/, x.toString()); })
                            .when(function (x) { return _this.evaluateActivation(x, rulesHolder); })
                            .withMessage(rule.errorMessage);
                    }
                    break;
                case ValidationTypeEnum.Date:
                    {
                        ruleValidation = ruleValidation
                            .satisfies(function (x, o) { return x === null || x === undefined || x === "" || _this.dateValidator.validate(parameters, x, o); })
                            .when(function (x) { return _this.evaluateActivation(x, rulesHolder); })
                            .withMessage(rule.errorMessage);
                    }
                    break;
                case ValidationTypeEnum.Compare:
                    {
                        ruleValidation = ruleValidation
                            .satisfies(function (x, o) { return _this.compareValidator.validate(parameters, o); })
                            .when(function (x) { return _this.evaluateActivation(x, rulesHolder); })
                            .withMessage(rule.errorMessage);
                    }
                    break;
                default:
                    break;
            }
            ruleValidation = rule.errorMessage ? ruleValidation.withMessage(rule.errorMessage) : ruleValidation;
        };
        for (var i = 0; i < rulesHolder.rules.length; i++) {
            _loop_1(i);
        }
        this.applyNestedValidations(rulesHolder, item, subscriptions);
        if (item && ruleValidation) {
            if (rulesHolder.isCollection) {
                item.forEach(function (element) {
                    element["__rules__"] = [];
                    ruleValidation.on(element);
                });
                var subscription = this.bindingEngine.collectionObserver(item).subscribe(function (changedValues) {
                    var countNew = changedValues[0].addedCount;
                    var startIndex = changedValues[0].index;
                    var addedValues = (item).slice(startIndex, startIndex + countNew);
                    addedValues.forEach(function (x) {
                        x["__rules__"] = [];
                        ruleValidation.on(x);
                    });
                    _this.applyNestedValidations(rulesHolder, addedValues, subscriptions);
                });
                subscriptions.push(subscription);
            }
            else {
                item["__rules__"] = [];
                ruleValidation.on(item);
            }
        }
        return ruleValidation;
    };
    EntityValidationsService.prototype.applyNestedValidations = function (rulesHolder, item, subscriptions) {
        var _this = this;
        var _loop_2 = function (j) {
            if (rulesHolder.isCollection && item) {
                item.forEach(function (element) {
                    if (element[rulesHolder.nestedRulesHolder[j].entityName]) {
                        _this.injectValidationRulesInEntity(rulesHolder.nestedRulesHolder[j], element[rulesHolder.nestedRulesHolder[j].entityName], subscriptions);
                    }
                    _this.injectValidationRulesInEntity(rulesHolder.nestedRulesHolder[j], element[rulesHolder.nestedRulesHolder[j].entityName], subscriptions);
                });
            }
            else {
                if (item && item[rulesHolder.nestedRulesHolder[j].entityName]) {
                    this_1.injectValidationRulesInEntity(rulesHolder.nestedRulesHolder[j], item[rulesHolder.nestedRulesHolder[j].entityName], subscriptions);
                }
            }
        };
        var this_1 = this;
        for (var j = 0; j < rulesHolder.nestedRulesHolder.length; j++) {
            _loop_2(j);
        }
    };
    EntityValidationsService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [ValidationController, BindingEngine])
    ], EntityValidationsService);
    return EntityValidationsService;
}());
export { EntityValidationsService };
var ClientSideValidator = /** @class */ (function () {
    function ClientSideValidator(validationController, subscriptions) {
        this.validationController = validationController;
        this.subscriptions = subscriptions;
        this.disposed = false;
    }
    ClientSideValidator.prototype.validate = function () {
        if (this.disposed) {
            throw new Error("Instance was disposed and cannot be reused");
        }
        else {
            return this.validationController.validate();
        }
    };
    ClientSideValidator.prototype.addError = function (message, obj, property) {
        this.validationController.addError(message, obj, property);
    };
    Object.defineProperty(ClientSideValidator.prototype, "isDisposed", {
        get: function () {
            return this.disposed;
        },
        enumerable: false,
        configurable: true
    });
    ClientSideValidator.prototype.dispose = function () {
        try {
            if (this.subscriptions) {
                this.subscriptions.forEach(function (subscription) {
                    if (subscription) {
                        subscription.dispose();
                    }
                });
            }
            this.disposed = true;
        }
        catch (exception) {
            throw exception;
        }
    };
    return ClientSideValidator;
}());
export { ClientSideValidator };
